export default __webpack_public_path__ + "img/MYMY-logo.b83b44db89dde9e34fce2e7df702de13.svg";